/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.85"
        height="16.12"
        viewBox="0 0 18.85 16.12"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 4.39v11.73h18.85V4.44h-2.37V0L.11 4.36ZM15.48 1.3v3.14H3.7ZM1 5.44h16.85v9.68H1Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'WalletIcon';

export default Icon;
